var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('app-subscribers',{attrs:{"custom-field-column":_vm.custom_fields}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }